import { z } from 'zod';
import { transcriptionProviderSchema } from './enums.js';
/** One reviewable word: text, its span in the recording, and 0-1 confidence. */
export const segmentWordSchema = z.object({
    t: z.string(),
    s: z.number(),
    e: z.number(),
    p: z.number().nullable(),
});
export const transcriptSegmentSchema = z.object({
    id: z.string(),
    idx: z.number(),
    speaker: z.string(),
    startSec: z.number(),
    endSec: z.number(),
    text: z.string(),
    language: z.string().nullable(),
    confidence: z.number().nullable(),
    words: z.array(segmentWordSchema).nullable(),
});
export const transcriptResponseSchema = z.object({
    transcript: z
        .object({
        id: z.string(),
        provider: z.string(),
        model: z.string(),
        version: z.number(),
        fullText: z.string(),
        costUsd: z.number().nullable(),
        createdAt: z.string(),
    })
        .nullable(),
    segments: z.array(transcriptSegmentSchema),
    audioUrl: z.string().nullable(),
});
export const updateSegmentInputSchema = z
    .object({
    text: z.string().max(5000).optional(),
    speaker: z.string().max(120).optional(),
})
    .refine((v) => v.text !== undefined || v.speaker !== undefined, {
    message: 'text or speaker is required',
});
export const speakerMappingSchema = z.object({
    from: z.string().min(1).max(120),
    to: z.string().min(1).max(120),
    attendeeId: z.string().nullish(),
});
export const updateSpeakersInputSchema = z.object({
    mappings: z.array(speakerMappingSchema).min(1).max(30),
});
export const retranscribeInputSchema = z.object({
    provider: transcriptionProviderSchema.optional(),
});
export const transcriptVersionQuerySchema = z.object({
    version: z.coerce.number().int().min(1).optional(),
});
export const transcriptVersionSchema = z.object({
    version: z.number(),
    provider: z.string(),
    model: z.string(),
    createdAt: z.string(),
    segments: z.number(),
});
export const transcriptVersionsResponseSchema = z.object({
    items: z.array(transcriptVersionSchema),
});
// ---------- import an existing transcript (skip transcription) ----------
export const importTranscriptSpeakerSchema = z.object({
    label: z.string().min(1).max(120),
    name: z.string().min(1).max(200),
});
export const importTranscriptSegmentSchema = z
    .object({
    speaker: z.string().min(1).max(120),
    startSec: z.number().min(0),
    endSec: z.number(),
    text: z.string().min(1).max(4000),
})
    .refine((v) => v.endSec >= v.startSec, {
    message: 'endSec must be >= startSec',
    path: ['endSec'],
});
export const importTranscriptInputSchema = z.object({
    provider: z.string().min(1).max(40),
    model: z.string().min(1).max(120).optional(),
    language: z.enum(['ar', 'en', 'mixed']).optional(),
    speakers: z.array(importTranscriptSpeakerSchema).min(1).max(50).optional(),
    segments: z.array(importTranscriptSegmentSchema).min(1).max(5000),
});
//# sourceMappingURL=transcripts.js.map